import type { ReactNode } from 'react'
import { DateTime } from 'luxon'
import { isDefined, type AuditLog } from '@terros/common'
import { Text, Tooltip } from '@mantine/core'
import { formatDate } from '@front/model'
import { UserListItem } from '../terros'

const getModificationText = (isCreated: boolean, userName: string): string => {
  return isCreated ? `Created by ${userName}` : `Modified by ${userName}`
}

export const ModificationEntry = ({
  modification: { userId, timestamp },
  isCreated = false,
}: {
  modification: AuditLog
  isCreated?: boolean
}): ReactNode => {
  return (
    <UserListItem userId={userId} label={({ userName }) => getModificationText(isCreated, userName)}>
      {isDefined(timestamp) ? (
        <Tooltip label={formatDate(timestamp, { format: 'MMM d, yyyy hh:mm a ZZZZ' })}>
          <Text size='sm' c='dimmed'>
            {DateTime.fromMillis(timestamp).toRelative()}
          </Text>
        </Tooltip>
      ) : (
        <Text size='sm' c='dimmed'>
          Unknown time
        </Text>
      )}
    </UserListItem>
  )
}
